import { render, staticRenderFns } from "./dfImage.vue?vue&type=template&id=07ea3b9f&scoped=true"
import script from "./dfImage.vue?vue&type=script&lang=js"
export * from "./dfImage.vue?vue&type=script&lang=js"
import style0 from "./dfImage.vue?vue&type=style&index=0&id=07ea3b9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ea3b9f",
  null
  
)

export default component.exports